// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"9fbae502","254":"01f60eec","287":"7e4aefde","310":"19697d21","594":"ab6ed667","868":"df8c3c48","902":"2f73939d","999":"1193d8a2"}[chunkId] + ".chunk.js";
};